module.exports = __webpack_public_path__ + "static/media/26import-56.57f6152e.xlsx";